import React from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { SvgLazy } from '@mobi/component-library/Common/Svg/SvgLazy'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { MainContainer } from '@core/Components/Containers'
import { queryClient } from '@core/Data/ReactQuery'
import { postCreateFollowMeProfile } from '@core/Areas/FollowMe/helpers/api'
import { followMePrincipleProfileQuery } from '@core/Areas/FollowMe/helpers/queries'
import { SkeletonLoader } from '@core/Areas/FollowMe/Components/Common/SkeletonLoader'
import { SortButtonBar } from '@core/Areas/FollowMe/Components/Common/SortFeed/Components/SortButtonBar'
import { BetLoopTAndCsModal } from './Components/BetLoopTAndCsModal'
import { ProfileCreationDisplayTray } from './Components/ProfileCreationDisplayTray'
import { FeedContainerStyled } from '../Common/FollowMe.styles'

export const OnboardingManager: React.FC<{ onCompleteOnboarding(): void }> = ({
  onCompleteOnboarding,
}) => {
  const [isTCsModalOpen, setIsTCsModalOpen] = React.useState(true)
  const { data } = useQuery(followMePrincipleProfileQuery)

  const { mutate: createProfile, isPending: isCreatingProfile } = useMutation({
    mutationFn: postCreateFollowMeProfile,
    onSuccess() {
      queryClient.invalidateQueries(followMePrincipleProfileQuery)
    },
    onSettled() {
      setIsTCsModalOpen(false)
    },
  })

  const onAcceptAndContinueClick = () => {
    createProfile()
  }

  return (
    <MainContainer background='surface300'>
      <PageHeader title={<SvgLazy name='BetLoopHeaderLogo' height='4rem' color='white' />} />

      <Tabs>
        <TabButton content='Explore' isSelected onClick={() => null} />
        <TabButton content='Following' isSelected={false} onClick={() => null} />
      </Tabs>

      <SortButtonBar label='Next to Jump' onClick={() => null} />

      <FeedContainerStyled>
        <SkeletonLoader />
      </FeedContainerStyled>

      <BetLoopTAndCsModal
        isOpen={isTCsModalOpen}
        onAccept={onAcceptAndContinueClick}
        isCreatingProfile={isCreatingProfile}
      />

      <ProfileCreationDisplayTray profileData={data} onCompleteOnboarding={onCompleteOnboarding} />
    </MainContainer>
  )
}
